import React from "react";
import { Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from "reactstrap";

const NavbarNavigate = ({setOpenJquery, setOpen }) => {
    return (<div>
        <Navbar
            dark
            color="dark"
            expand="md"
            light
        >
            <NavbarBrand href="/">
                EDTS-TRACKER
            </NavbarBrand>
            <NavbarToggler onClick={function noRefCheck() { }} />
            <Collapse navbar>
                <Nav
                    pills 
                    className="me-auto"
                    navbar
                >
                    <NavItem>
                        <NavLink onClick={setOpen} href="#">
                           React.js Get Started 
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink onClick={setOpenJquery} href="#">
                           Jquery Get Started
                        </NavLink>
                    </NavItem>
                </Nav>
            </Collapse>
        </Navbar>
    </div>)
}
export default NavbarNavigate;